import React from 'react';

import Container from '../../ui/Container';

import * as Styled from './styles';

const Footer = () => (
  <Styled.Footer>
    <Container>
      <Styled.Links>
        <Styled.Link href="https://www.facebook.com/nxtgenfoundation" 
          rel="noreferrer noopener" 
          target="_blank">
          Facebook
        </Styled.Link>
        <Styled.Link
          href="https://nxtgenfoundation.medium.com/"
          rel="noreferrer noopener"
          target="_blank"
        >
          Medium
        </Styled.Link>
        <Styled.Link href="/" rel="noreferrer noopener" target="_blank">
          LinkedIn
        </Styled.Link>
      </Styled.Links>
    </Container>
  </Styled.Footer>
);

export default Footer;
